package de.oevbs.kunde.kundenportal2.model.services.registration

import de.oevbs.kunde.kundenportal2.ServiceInfo
import de.oevbs.sfa.communication.ClientDefinition
import de.oevbs.sfa.communication.ClientResponse
import kotlinx.serialization.Serializable

@Serializable
data class IdPayload(val id: String)

abstract class ResetUserPassClientDefinition(origin: String) : ClientDefinition(ServiceInfo, origin, ServiceInfo.name) {

    override val requestTimeoutMillis: Long = 30000L

    /**
     * Erstellt einen Password-Reset-Token für den übergebenen User/Partner und hinterlegt ihn in der CosmosDB am
     * Account. Der User erhält dann eine Mail mit einem Link, den er einmalig verwenden kann, um sein Passwort
     * zu ändern. Nach Klicken des Links gelangt er zu processPassToken().
     *
     * __Mocks__
     *
     * //TODO Mocks
     */
    suspend fun sendPassResetMail(usernameOrPartnerId: String): ClientResponse<Unit> =
        post("/reset/password", IdPayload(usernameOrPartnerId))

    /**
     * Speichert das neue Passwort [Reset.newPassword] des Users nach Prüfung des Pass-Reset-Tokens [Reset.token].
     *
     * __Mocks__
     *
     * //TODO Mocks
     */
    suspend fun saveNewPass(reset: Reset): ClientResponse<Unit> =
        post("/reset/password/save", reset)

    /**
     * Generiert einen User-Vergessen-Link in eine Mail nach dem Schema
     * https://xxx.kunde.oeffentliche.de/kundenportal2/reset/username/vycwq5Hs3jJrTWR9A3HfazsesLwGvmdF4j94X6h27ARWaZQ6v9,
     * den der User in der Mail anklicken kann, um seinen Benutzernamen zu erfahren. Der Name darf nicht per Mail
     * versendet werden.
     *
     * __Mocks__
     *
     * //TODO Mocks
     */
    suspend fun sendUserForgottenMail(partnerId: String): ClientResponse<Unit> =
        post("/reset/username", IdPayload(partnerId))

}